import { Component,OnInit } from '@angular/core';
import { NavController } from 'ionic-angular';
import {MyUrlService} from '../home/checkUrll';
import {MydataService} from '../home/mydata.service';
import {JsonData} from '../home/dataaa';
import  { Http } from '@angular/http';
import { LoadingController } from 'ionic-angular';
import {ProductviewPage} from '../productview/productview';
import {MyvariableService} from '../home/constantvariable';
import { AlertController } from 'ionic-angular';

@Component({
  selector: 'page-orderdetail',
  templateUrl: 'orderdetail.html',
  providers:[MydataService,MyUrlService,JsonData,MyvariableService]
})
export class OrderDetailPage implements OnInit
{
    orderhistorydetailDt:Array<JsonData>;
	orderlistdataDt:Array<JsonData>;
	jsonDt : Array<JsonData>;
	pcs= this.MyvariableService.PCS;
	ratinggdatta:any;
	orderratting:any;
	//deliverDatess:any;
    myParseInt = parseInt;
   constructor(public alerCtrl: AlertController,private MyvariableService: MyvariableService,private http:Http,public navCtrl: NavController,public loading: LoadingController,private mydataService: MydataService,private myurlService: MyUrlService) {}

   ngOnInit(){
	     //this.deliverDatess=window.localStorage.getItem('deliverDates');
		 
	     if(this.mydataService.checkInternetFunction()=="0"){
    ////console.log("Internet UnAvailable")
    }else  if(this.mydataService.checkInternetFunction()=="1"){

	   var bookingid=window.localStorage.getItem('booking');
	      //alert(bookingid);
		 var kiloSabjiJSONdata = JSON.stringify({"bookingid":bookingid});
	   let loader = this.loading.create({content: '',});
	   //console.log("Product Url--->"+this.myurlService.ORDERHISTORYDETAIL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);

	   	loader.present().then(() => {
    this.mydataService.postJSON(this.myurlService.ORDERHISTORYDETAIL,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.orderDetailService(loader));
  });

	}    }

errorFunction= function(loader,error){
		loader.dismiss();
		//console.log(error);
		//alert(error);
		}
	orderDetailService=function(loader){
		//console.log("all //console data"+JSON.stringify(this.jsonDt));
		 this.orderhistorydetailDt = this.jsonDt.bookingdata;
         this.orderlistdataDt =this.jsonDt.orderlistdata;
		 this.image= this.myurlService.IMAGEURL;
this.totalAmount = this.orderhistorydetailDt[0].totalAmount;
this.orderratting = this.jsonDt.bookingdata[0].rating;
this.discountAmount = this.orderhistorydetailDt[0].discountAmount;
this.billAmount = this.orderhistorydetailDt[0].billAmount;
this.orderNo = this.orderhistorydetailDt[0].orderNo;
this.orderDate = this.orderhistorydetailDt[0].orderDates;
this.deliverDatess = this.orderhistorydetailDt[0].deliverDate;
this.address = this.orderhistorydetailDt[0].address;
this.mobileNo = this.orderhistorydetailDt[0].mobileNo;
this.city = this.orderhistorydetailDt[0].city;
this.pincode = this.orderhistorydetailDt[0].pincode;
this.deliveryCharge= this.orderhistorydetailDt[0].deliveryCharge;
this.gstAmount = parseFloat(this.orderhistorydetailDt[0].SGSTamount) +parseFloat(this.orderhistorydetailDt[0].CGSTamount);
     //console.log("aaaaaaaaaaaa===========>"+this.gstAmount);
this.grossAmount = this.orderhistorydetailDt[0].taxableAmount;
if(this.orderratting==null){
					this.ratinggdatta=0;
				}else{
				this.ratinggdatta=this.orderratting;
				}
		//console.log("orderhistorydetail receive jsondata ==>"+JSON.stringify(this.jsonDt.bookingdata));
		//console.log("orderlistdata receive jsondata ==>"+JSON.stringify(this.jsonDt.orderlistdata));
			loader.dismiss();
        }
     
	 
		ratingPosition(ratpos,noooo){
			this.ratinggdatta=ratpos;
		}
		rating(){
		//console.log("this.ratinggdatta   "+this.ratinggdatta);
		if(this.ratinggdatta==0){
			this.alertRatingg("Please select rating");
			}else{
			//console.log("hi"+this.ratinggdatta);
				var kiloSabjiJSONdata = JSON.stringify({"userid":window.localStorage.getItem('userid'),"ratingis":this.ratinggdatta,"orderid":window.localStorage.getItem('booking')});
			////console.log("Product Url--->"+this.myurlService.ADDTOCARTURL+"\n"+"JSON Parameter--->"+kiloSabjiJSONdata);
			let loader = this.loading.create({content: '',});
			
			loader.present().then(() => {
				this.mydataService.postJSON(this.myurlService.RATINGWEBSERVICES ,kiloSabjiJSONdata).subscribe(data => this.jsonDt= data,error => this.errorFunction(loader,error),() =>this.ratingService(loader));
			});
		}
		}
		
		ratingService=function(loader){
			loader.dismiss();
			//console.log("rating===>"+JSON.stringify(this.jsonDt.datas));
			if(this.jsonDt.datas=="Updated Successfully"){
				this.alertRatingg("Thank you for your feedback.");
				this.orderratting=4;
				}
			//this.grossAmount = this.orderhistorydetailDt[0].taxableAmount;
		}
	 productview(bookingid)
		{
			
			window.localStorage.setItem('booking',bookingid);
			//alert(bookingid);
			this.navCtrl.push(ProductviewPage);
		}
		alertRatingg=function(ratting) {
		////console.log("aaaaaaaaaaaaaa"+ratting);
		let alert = this.alerCtrl.create({
			// title: 'New Friend!',
			subTitle: ratting,
			buttons: ['OK']
		});
		alert.present();
	}
   }





// WEBPACK FOOTER //
// ./src/pages/orderdetail/orderdetail.ts